import { render, staticRenderFns } from "./vbdatapickerWeek.vue?vue&type=template&id=7925677a&scoped=true&"
import script from "./vbdatapickerWeek.vue?vue&type=script&lang=js&"
export * from "./vbdatapickerWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7925677a",
  null
  
)

export default component.exports